import { render, staticRenderFns } from "./equipmentRecordDetail.vue?vue&type=template&id=5b5ee372"
import script from "./equipmentRecordDetail.vue?vue&type=script&lang=js"
export * from "./equipmentRecordDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b5ee372')) {
      api.createRecord('5b5ee372', component.options)
    } else {
      api.reload('5b5ee372', component.options)
    }
    module.hot.accept("./equipmentRecordDetail.vue?vue&type=template&id=5b5ee372", function () {
      api.rerender('5b5ee372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/inspection/equipmentRecordDetail.vue"
export default component.exports